import { gql } from '@apollo/client';

export const CHANGE_PASSWORD = gql`
  mutation ChangePassword($current: String!, $next: String!, $confirm: String!) {
    changePassword(input: { currentPassword: $current, newPassword: $next, confirmPassword: $confirm }) {
      success
      errors
    }
  }
`;
